import React from 'react';
import { HERO_GRADIENT } from './landingConstants';

const STATS = [
  { value: '16', label: 'instituciones' },
  { value: '+23.000', label: 'alumnos' },
  { value: '360°', label: 'visión integral' },
];

export const LandingStats = () => (
  <section style={{ background: HERO_GRADIENT }} className="py-14" data-testid="landing-stats">
    <div className="max-w-5xl mx-auto px-6 grid grid-cols-3 gap-6 text-center">
      {STATS.map((stat) => (
        <div key={stat.label} data-testid={`landing-stat-${stat.label.replace(/\s/g, '-')}`}>
          <p className="font-manrope text-3xl sm:text-4xl font-extrabold text-white tabular-nums">{stat.value}</p>
          <p className="text-white/80 text-sm mt-1">{stat.label}</p>
        </div>
      ))}
    </div>
  </section>
);
